// @ts-nocheck

import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';

import useRouter from '../../../../hooks/useRouter';
import { getLang } from '../../../../i18n/l10n';
import { RoutePatterns } from '../../../../types/routes';
import RoutesRedirectionFactory from '../../../../utils/routes/RoutesRedirectionFactory';
import GridsBasketRouteUpdateContainer from '../../containers/basket/GridsBasketRouteUpdateContainer';
import { isGridsAllowed } from '../../utils';

type GridsRouteWatcherProps = {
  shouldInit: boolean;
  init: () => void;
};

const GridsRouteWatcher = ({ shouldInit, init }: GridsRouteWatcherProps) => {
  const { history } = useRouter();

  useEffect(() => {
    init();
  }, [init]);

  useEffect(() => {
    if (shouldInit) {
      init();
    }
  }, [init, shouldInit]);

  if (!isGridsAllowed(getLang())) {
    history.push(RoutesRedirectionFactory.getHomeRouteConfig());
  }

  return (
    <Switch>
      <Route path={RoutePatterns.GRID_SHARE} component={GridsBasketRouteUpdateContainer} exact />
      <Route path={RoutePatterns.GRID_HISTORY_DETAIL} component={GridsBasketRouteUpdateContainer} exact />
      <Route path={RoutePatterns.GRID_PUBLIC} component={GridsBasketRouteUpdateContainer} exact />
      <Route path={RoutePatterns.POOL} component={GridsBasketRouteUpdateContainer} exact />
    </Switch>
  );
};

export default GridsRouteWatcher;
